export function usePageMeta({ title, description, canonicalPath, breadcrumbs = [], jsonLd = {} }) {
    // Set document title
    if (title) {
        document.title = title;
    }

    // Set meta description
    if (description) {
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', description);
    }

    // Set canonical link
    const BASE_URL = 'https://jalkojesitahden.fi';
    if (canonicalPath) {
        const href = canonicalPath.startsWith('http') ? canonicalPath : `${BASE_URL}${canonicalPath}`;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', href);
    }

    // Inject BreadcrumbList JSON-LD
    if (breadcrumbs && breadcrumbs.length > 0) {
        const scriptId = 'jsonld-breadcrumbs';
        let script = document.getElementById(scriptId);
        if (!script) {
            script = document.createElement('script');
            script.type = 'application/ld+json';
            script.id = scriptId;
            document.head.appendChild(script);
        }
        const breadcrumbJson = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((crumb, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: crumb.name,
                item: crumb.url
            }))
        };
        script.textContent = JSON.stringify(breadcrumbJson);
    }

    // Inject additional page-specific JSON-LD (e.g., WebPage)
    if (jsonLd && Object.keys(jsonLd).length > 0) {
        const scriptId = 'jsonld-page';
        let script = document.getElementById(scriptId);
        if (!script) {
            script = document.createElement('script');
            script.type = 'application/ld+json';
            script.id = scriptId;
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(jsonLd);
    }
}


